import { formatNumber } from '@web-platform/shared-universal-utils-frontend-localisation';

import { translate } from '../translate';

export const getHotelReviewCountTranslation = (count?: number) => {
  if (!count) {
    return undefined;
  }

  if (count >= 10) {
    return translate('ktxt_hotels_cross_sell_reviews_x').replace(
      '{0}',
      String(
        formatNumber(count, {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        }),
      ),
    );
  }

  switch (count) {
    case 1:
      return translate('ktxt_hotels_cross_sell_reviews_1');
    case 2:
      return translate('ktxt_hotels_cross_sell_reviews_2');
    case 3:
      return translate('ktxt_hotels_cross_sell_reviews_3');
    case 4:
      return translate('ktxt_hotels_cross_sell_reviews_4');
    case 5:
      return translate('ktxt_hotels_cross_sell_reviews_5');
    case 6:
      return translate('ktxt_hotels_cross_sell_reviews_6');
    case 7:
      return translate('ktxt_hotels_cross_sell_reviews_7');
    case 8:
      return translate('ktxt_hotels_cross_sell_reviews_8');
    case 9:
      return translate('ktxt_hotels_cross_sell_reviews_9');
    default:
      return undefined;
  }
};

export const getHotelReviewRatingTranslation = (score: number) => {
  if (score > 4.5) {
    return translate('ktxt_hotels_cross_sell_rating_honors');
  }
  if (score > 4) {
    return translate('ktxt_hotels_cross_sell_rating_excellent');
  }
  if (score > 3.5) {
    return translate('ktxt_hotels_cross_sell_rating_very_good');
  }
  if (score > 3) {
    return translate('ktxt_hotels_cross_sell_rating_good');
  }
  if (score > 1.5) {
    return translate('ktxt_hotels_cross_sell_rating_satisfactory');
  }
  if (score > 0) {
    return translate('ktxt_hotels_cross_sell_rating_average');
  }
  return translate('ktxt_hotels_cross_sell_rating_below_average');
};

export const getHotelStarsLabelTranslation = (stars: number) => {
  switch (stars) {
    case 1:
      return translate('ktxt_hotels_cross_sell_stars_1');
    case 2:
      return translate('ktxt_hotels_cross_sell_stars_2');
    case 3:
      return translate('ktxt_hotels_cross_sell_stars_3');
    case 4:
      return translate('ktxt_hotels_cross_sell_stars_4');
    case 5:
    default:
      return translate('ktxt_hotels_cross_sell_stars_5');
  }
};
